import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatApiError } from "@/lib/api";
import { Loader2, ArrowRight, ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSuccess("If the email exists, a password reset link has been sent to your email.");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="forgot-password-page">
      {/* Left - Form */}
      <div className="flex-1 flex items-center justify-center p-8 md:p-12">
        <div className="w-full max-w-sm">
          <div className="mb-12">
            <h1
              className="text-4xl sm:text-5xl tracking-tighter font-medium text-slate-950"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              PayrollKE
            </h1>
            <p className="mt-2 text-sm text-slate-500">
              Reset your password
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 block mb-2">
                Email
              </label>
              <input
                data-testid="forgot-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-white border border-slate-200 rounded-sm px-4 py-2.5 w-full focus:outline-none focus:ring-2 focus:ring-[#002FA7]/30 focus:border-[#002FA7] transition-all text-sm"
                placeholder="Enter your email"
                required
              />
            </div>

            {error && (
              <div
                data-testid="forgot-error"
                className="bg-[#FEF2F2] border border-[#EF4444] text-[#991B1B] text-sm px-4 py-3 rounded-sm"
              >
                {error}
              </div>
            )}

            {success && (
              <div
                data-testid="forgot-success"
                className="bg-[#F0FDF4] border border-[#22C55E] text-[#15803D] text-sm px-4 py-3 rounded-sm"
              >
                {success}
              </div>
            )}

            <button
              data-testid="forgot-submit-button"
              type="submit"
              disabled={loading}
              className="bg-[#002FA7] hover:bg-[#002480] text-white rounded-sm px-6 py-2.5 font-medium transition-colors focus:ring-2 focus:ring-[#002FA7]/30 w-full flex items-center justify-center gap-2 text-sm"
            >
              {loading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <>
                  Send Reset Link <ArrowRight className="h-4 w-4" />
                </>
              )}
            </button>

            <div className="text-center">
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="text-sm text-[#002FA7] hover:text-[#002480] underline flex items-center justify-center gap-1"
              >
                <ArrowLeft className="h-4 w-4" />
                Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Right - Image */}
      <div className="hidden lg:block lg:w-1/2 relative">
        <img
          src="https://images.unsplash.com/photo-1513694203232-719a280e022f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjBhcmNoaXRlY3R1cmUlMjB3aGl0ZSUyMGNsZWFufGVufDB8fHx8MTc3NjI1MjM3MHww&ixlib=rb-4.1.0&q=85"
          alt="Architecture"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-white/10" />
      </div>
    </div>
  );
}